import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=dedc1c50&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=ts&"
export * from "./Header.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=dedc1c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedc1c50",
  null
  
)

export default component.exports